import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetLikedUsersFailed, EGetLikedUsersActionType, TGetLikedUsersParams } from './types';

export const getLikedUsersFailed: (data: TGetLikedUsersParams) => TGetLikedUsersFailed = actionGenerator<
  EGetLikedUsersActionType.Failed,
  TGetLikedUsersParams
>(EGetLikedUsersActionType.Failed);
